// import React, { useState, useEffect, useRef } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { 
//   FiPrinter, 
//   FiDownload, 
//   FiFileText,
//   FiHome,
//   FiUser,
//   FiMapPin,
//   FiCalendar,
//   FiCheckCircle,
//   FiArrowLeft,
//   FiShare2,
//   FiMail,
//   FiExternalLink
// } from 'react-icons/fi';
// import {
//   MdAttachMoney,
//   MdPictureAsPdf,
//   MdReceiptLong,
//   MdWaterDrop,
//   MdHealthAndSafety,
//   MdLandscape,
//   MdBusiness,
//   MdAccountBalance,
//   MdLocationCity
// } from 'react-icons/md';
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';

// const PrintPDF = () => {
//   const { propertyId } = useParams();
//   const navigate = useNavigate();
//   const pdfRef = useRef();
//   const [language, setLanguage] = useState('english');
//   const [propertyData, setPropertyData] = useState(null);
//   const [taxData, setTaxData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [generatingPDF, setGeneratingPDF] = useState(false);
//   const [pdfGenerated, setPdfGenerated] = useState(false);

//   // Government of Maharashtra color scheme
//   const colors = {
//     primary: '#003366',
//     secondary: '#FF9933',
//     accent: '#138808',
//     white: '#FFFFFF'
//   };

//   // Sample data (in real app, fetch from API)
//   const sampleData = {
//     property: {
//       id: propertyId || 'PR-2024-1001',
//       sequenceNumber: 'PR-2024-1001',
//       ownerName: 'राजेश कुमार',
//       newPropertyNumber: 'NPR-24001',
//       oldPropertyNumber: 'OPR-20101',
//       address: 'हाउस नंबर १२३, शिवाजी नगर, पुणे - ४११०४२',
//       landArea: '1200',
//       buildingArea: '1500',
//       buildingType: 'Residential',
//       annualValue: '72000',
//       capitalValue: '1800000',
//       registrationDate: '१५ जानेवारी २०२४',
//       wardNumber: '१२',
//       zone: 'पुणे विभाग'
//     },
//     tax: {
//       landTax: 12000,
//       buildingTax: 22500,
//       waterTax: 8000,
//       healthTax: 5760,
//       totalTax: 48260,
//       taxYear: '२०२४-२०२५',
//       dueDate: '३१ मार्च २०२५',
//       paymentDeadline: '३१ मार्च २०२५',
//       receiptNumber: 'RCPT-2024-001245',
//       issueDate: '२५ जानेवारी २०२४',
//       calculationMethod: 'नमुना ८'
//     }
//   };

//   // Language content
//   const content = {
//     english: {
//       pageTitle: 'Print / PDF Preview',
//       pageSubtitle: 'Preview and generate tax receipt PDF',
//       preview: 'PDF Preview',
//       receiptDetails: 'Receipt Details',
//       propertyInfo: 'Property Information',
//       taxBreakdown: 'Tax Breakdown',
//       summary: 'Tax Summary',
//       headers: {
//         maharashtraGovt: 'Government of Maharashtra',
//         department: 'Revenue Department',
//         receiptTitle: 'PROPERTY TAX RECEIPT',
//         receiptSubtitle: 'नमुना ८ (Format 8)',
//         gramPanchayat: 'Gram Panchayat - Shivaji Nagar'
//       },
//       labels: {
//         receiptNo: 'Receipt No.',
//         date: 'Date',
//         propertyId: 'Property ID',
//         ownerName: 'Owner Name',
//         address: 'Address',
//         landArea: 'Land Area',
//         buildingArea: 'Building Area',
//         buildingType: 'Building Type',
//         wardNo: 'Ward No.',
//         zone: 'Zone',
//         landTax: 'Land Tax',
//         buildingTax: 'Building Tax',
//         waterTax: 'Water Tax',
//         healthTax: 'Health Tax',
//         totalTax: 'Total Tax',
//         taxYear: 'Tax Year',
//         dueDate: 'Due Date',
//         paymentMode: 'Payment Mode',
//         paymentStatus: 'Payment Status',
//         authorizedBy: 'Authorized By'
//       },
//       buttons: {
//         print: 'Print Receipt',
//         downloadPDF: 'Download PDF',
//         generatePDF: 'Generate PDF',
//         share: 'Share',
//         email: 'Email PDF',
//         back: 'Back to Tax Calculation'
//       },
//       messages: {
//         loading: 'Loading receipt data...',
//         generating: 'Generating PDF...',
//         generated: 'PDF generated successfully!',
//         downloading: 'Downloading PDF...',
//         printed: 'Receipt printed successfully!'
//       },
//       notes: {
//         note1: 'This is an official receipt for property tax payment.',
//         note2: 'Please keep this receipt for future reference.',
//         note3: 'Late payments will attract penalty charges.',
//         note4: 'For any queries, contact Gram Panchayat office.'
//       }
//     },
//     marathi: {
//       pageTitle: 'प्रिंट / पीडीएफ पूर्वावलोकन',
//       pageSubtitle: 'कर पावती पीडीएफ पूर्वावलोकन आणि तयार करा',
//       preview: 'पीडीएफ पूर्वावलोकन',
//       receiptDetails: 'पावती तपशील',
//       propertyInfo: 'मालमत्ता माहिती',
//       taxBreakdown: 'कर विभागणी',
//       summary: 'कर सारांश',
//       headers: {
//         maharashtraGovt: 'महाराष्ट्र शासन',
//         department: 'राजस्व विभाग',
//         receiptTitle: 'मालमत्ता कर पावती',
//         receiptSubtitle: 'नमुना ८ (Format 8)',
//         gramPanchayat: 'ग्रामपंचायत - शिवाजी नगर'
//       },
//       labels: {
//         receiptNo: 'पावती क्रमांक',
//         date: 'तारीख',
//         propertyId: 'मालमत्ता आयडी',
//         ownerName: 'मालकाचे नाव',
//         address: 'पत्ता',
//         landArea: 'जमीन क्षेत्रफळ',
//         buildingArea: 'इमारत क्षेत्रफळ',
//         buildingType: 'इमारत प्रकार',
//         wardNo: 'वॉर्ड क्रमांक',
//         zone: 'विभाग',
//         landTax: 'जमीन कर',
//         buildingTax: 'इमारत कर',
//         waterTax: 'पाणी कर',
//         healthTax: 'आरोग्य कर',
//         totalTax: 'एकूण कर',
//         taxYear: 'कर वर्ष',
//         dueDate: 'पेमेंट कालबाह्य',
//         paymentMode: 'पेमेंट पद्धत',
//         paymentStatus: 'पेमेंट स्थिती',
//         authorizedBy: 'अधिकृत केले'
//       },
//       buttons: {
//         print: 'पावती प्रिंट करा',
//         downloadPDF: 'पीडीएफ डाउनलोड करा',
//         generatePDF: 'पीडीएफ तयार करा',
//         share: 'शेअर करा',
//         email: 'पीडीएफ ईमेल करा',
//         back: 'कर गणनाकडे परत'
//       },
//       messages: {
//         loading: 'पावती डेटा लोड करत आहे...',
//         generating: 'पीडीएफ तयार करत आहे...',
//         generated: 'पीडीएफ यशस्वीरित्या तयार केली!',
//         downloading: 'पीडीएफ डाउनलोड करत आहे...',
//         printed: 'पावती यशस्वीरित्या प्रिंट केली!'
//       },
//       notes: {
//         note1: 'ही मालमत्ता कर पेमेंटसाठी अधिकृत पावती आहे.',
//         note2: 'भविष्यातील संदर्भासाठी ही पावती जतन करा.',
//         note3: 'उशीरा पेमेंटसाठी दंड शुल्क आकारले जाईल.',
//         note4: 'कोणत्याही प्रश्नासाठी, ग्रामपंचायत कार्यालयाशी संपर्क साधा.'
//       }
//     }
//   };

//   // Format currency in Indian Rupees
//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: 'INR',
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0
//     }).format(amount);
//   };

//   // Format date
//   const formatDate = () => {
//     return new Date().toLocaleDateString('en-IN', {
//       day: 'numeric',
//       month: 'long',
//       year: 'numeric'
//     });
//   };

//   // Load data
//   useEffect(() => {
//     // Simulate API call
//     setTimeout(() => {
//       setPropertyData(sampleData.property);
//       setTaxData(sampleData.tax);
//       setLoading(false);
//     }, 1000);
//   }, [propertyId]);

//   const generatePDF = async () => {
//     setGeneratingPDF(true);
    
//     try {
//       const input = pdfRef.current;
//       const canvas = await html2canvas(input, {
//         scale: 2,
//         useCORS: true,
//         logging: false,
//         backgroundColor: '#ffffff'
//       });
      
//       const imgData = canvas.toDataURL('image/png');
//       const pdf = new jsPDF('p', 'mm', 'a4');
//       const imgWidth = 190;
//       const pageHeight = 295;
//       const imgHeight = (canvas.height * imgWidth) / canvas.width;
//       let heightLeft = imgHeight;
//       let position = 10;

//       pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
//       heightLeft -= pageHeight;

//       while (heightLeft >= 0) {
//         position = heightLeft - imgHeight;
//         pdf.addPage();
//         pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
//         heightLeft -= pageHeight;
//       }

//       pdf.save(`Property_Tax_Receipt_${propertyData.sequenceNumber}.pdf`);
//       setPdfGenerated(true);
//       alert(content[language].messages.generated);
//     } catch (error) {
//       console.error('Error generating PDF:', error);
//       alert('Error generating PDF. Please try again.');
//     } finally {
//       setGeneratingPDF(false);
//     }
//   };

//   const handlePrint = () => {
//     window.print();
//     alert(content[language].messages.printed);
//   };

//   const handleDownload = () => {
//     generatePDF();
//   };

//   const handleShare = () => {
//     alert('Share functionality would be implemented here');
//   };

//   const handleEmail = () => {
//     alert('Email functionality would be implemented here');
//   };

//   const handleBack = () => {
//     navigate('/calculate-tax');
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50">
//         <div className="text-center">
//           <div className="w-16 h-16 mx-auto mb-4 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
//           <p className="text-gray-600">{content[language].messages.loading}</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen p-4 md:p-6 bg-gradient-to-b from-gray-50 to-gray-100">
//       {/* Header */}
//       <div className="mb-8">
//         <div className="flex flex-col md:flex-row md:items-center justify-between mb-6">
//           <div>
//             <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
//               {content[language].pageTitle}
//             </h1>
//             <p className="text-gray-600">
//               {content[language].pageSubtitle}
//             </p>
//           </div>
          
//           {/* Language Toggle */}
//           <div className="mt-4 md:mt-0">
//             <div className="inline-flex rounded-lg border border-gray-300 p-1">
//               <button
//                 onClick={() => setLanguage('english')}
//                 className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
//                   language === 'english'
//                     ? 'bg-blue-600 text-white'
//                     : 'text-gray-700 hover:bg-gray-100'
//                 }`}
//               >
//                 English
//               </button>
//               <button
//                 onClick={() => setLanguage('marathi')}
//                 className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
//                   language === 'marathi'
//                     ? 'bg-blue-600 text-white'
//                     : 'text-gray-700 hover:bg-gray-100'
//                 }`}
//               >
//                 मराठी
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//         {/* PDF Preview - Left Column */}
//         <div className="lg:col-span-2">
//           <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
//             <div className="flex items-center justify-between mb-6">
//               <div className="flex items-center">
//                 <div className="w-10 h-10 rounded-lg bg-red-100 flex items-center justify-center mr-4">
//                   <MdPictureAsPdf size={24} className="text-red-600" />
//                 </div>
//                 <div>
//                   <h2 className="text-xl font-bold text-gray-800">
//                     {content[language].preview}
//                   </h2>
//                   <p className="text-gray-600 text-sm">
//                     {language === 'english' 
//                       ? 'Preview of the official tax receipt'
//                       : 'अधिकृत कर पावतीचे पूर्वावलोकन'}
//                   </p>
//                 </div>
//               </div>
              
//               <div className="flex items-center space-x-2">
//                 <span className={`px-3 py-1 text-xs font-medium rounded-full ${
//                   pdfGenerated ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
//                 }`}>
//                   {pdfGenerated ? 'PDF Ready' : 'Preview Mode'}
//                 </span>
//               </div>
//             </div>

//             {/* PDF Content */}
//             <div 
//               ref={pdfRef}
//               className="bg-white border-2 border-gray-300 rounded-lg p-6 md:p-8 print:border-0 print:shadow-none"
//               style={{ minHeight: '800px' }}
//             >
//               {/* Government Header */}
//               <div className="text-center mb-8 border-b-2 border-gray-300 pb-6">
//                 <div className="flex items-center justify-center mb-4">
//                   <div className="w-16 h-16 rounded-full bg-blue-600 flex items-center justify-center mr-4">
//                     <span className="text-white text-2xl font-bold">महा</span>
//                   </div>
//                   <div>
//                     <h1 className="text-2xl font-bold text-gray-900" style={{ color: colors.primary }}>
//                       {content[language].headers.maharashtraGovt}
//                     </h1>
//                     <h2 className="text-lg text-gray-700">
//                       {content[language].headers.department}
//                     </h2>
//                   </div>
//                 </div>
                
//                 <div className="mt-4">
//                   <h3 className="text-xl font-bold text-gray-900 mb-2">
//                     {content[language].headers.receiptTitle}
//                   </h3>
//                   <p className="text-gray-700 font-medium">
//                     {content[language].headers.receiptSubtitle}
//                   </p>
//                   <p className="text-gray-600 mt-1">
//                     {content[language].headers.gramPanchayat}
//                   </p>
//                 </div>
//               </div>

//               {/* Receipt Details */}
//               <div className="mb-8">
//                 <div className="flex justify-between items-center mb-6">
//                   <div>
//                     <h4 className="text-lg font-bold text-gray-900 mb-2">
//                       {content[language].receiptDetails}
//                     </h4>
//                     <div className="grid grid-cols-2 gap-4">
//                       <div>
//                         <p className="text-sm text-gray-600">{content[language].labels.receiptNo}</p>
//                         <p className="font-bold text-gray-900">{taxData.receiptNumber}</p>
//                       </div>
//                       <div>
//                         <p className="text-sm text-gray-600">{content[language].labels.date}</p>
//                         <p className="font-bold text-gray-900">{formatDate()}</p>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="text-right">
//                     <div className="inline-block px-4 py-2 bg-green-100 text-green-800 rounded-lg">
//                       <FiCheckCircle className="inline mr-2" />
//                       <span className="font-bold">PAID</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Property Information */}
//               <div className="mb-8">
//                 <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
//                   <FiHome className="mr-2" />
//                   {content[language].propertyInfo}
//                 </h4>
                
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                   <div className="space-y-3">
//                     <div>
//                       <p className="text-sm text-gray-600">{content[language].labels.propertyId}</p>
//                       <p className="font-bold text-gray-900">{propertyData.sequenceNumber}</p>
//                     </div>
//                     <div>
//                       <p className="text-sm text-gray-600">{content[language].labels.ownerName}</p>
//                       <p className="font-bold text-gray-900">{propertyData.ownerName}</p>
//                     </div>
//                     <div>
//                       <p className="text-sm text-gray-600">{content[language].labels.landArea}</p>
//                       <p className="font-bold text-gray-900">{parseInt(propertyData.landArea).toLocaleString()} sq. ft.</p>
//                     </div>
//                     <div>
//                       <p className="text-sm text-gray-600">{content[language].labels.wardNo}</p>
//                       <p className="font-bold text-gray-900">{propertyData.wardNumber}</p>
//                     </div>
//                   </div>
                  
//                   <div className="space-y-3">
//                     <div>
//                       <p className="text-sm text-gray-600">{content[language].labels.address}</p>
//                       <p className="font-bold text-gray-900">{propertyData.address}</p>
//                     </div>
//                     <div>
//                       <p className="text-sm text-gray-600">{content[language].labels.buildingArea}</p>
//                       <p className="font-bold text-gray-900">{parseInt(propertyData.buildingArea).toLocaleString()} sq. ft.</p>
//                     </div>
//                     <div>
//                       <p className="text-sm text-gray-600">{content[language].labels.buildingType}</p>
//                       <p className="font-bold text-gray-900">{propertyData.buildingType}</p>
//                     </div>
//                     <div>
//                       <p className="text-sm text-gray-600">{content[language].labels.zone}</p>
//                       <p className="font-bold text-gray-900">{propertyData.zone}</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Tax Breakdown */}
//               <div className="mb-8">
//                 <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
//                   <MdReceiptLong className="mr-2" />
//                   {content[language].taxBreakdown}
//                 </h4>
                
//                 <div className="overflow-x-auto">
//                   <table className="min-w-full divide-y divide-gray-200">
//                     <thead>
//                       <tr>
//                         <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 bg-gray-50">
//                           {language === 'english' ? 'Tax Component' : 'कर घटक'}
//                         </th>
//                         <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 bg-gray-50">
//                           {language === 'english' ? 'Calculation' : 'गणना'}
//                         </th>
//                         <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 bg-gray-50">
//                           {language === 'english' ? 'Amount (₹)' : 'रक्कम (₹)'}
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody className="divide-y divide-gray-200">
//                       <tr>
//                         <td className="px-4 py-3 text-sm font-medium text-gray-900">
//                           <div className="flex items-center">
//                             <MdLandscape className="mr-2 text-blue-600" />
//                             {content[language].labels.landTax}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3 text-sm text-gray-600">
//                           {propertyData.landArea} sq. ft. × ₹10
//                         </td>
//                         <td className="px-4 py-3 text-sm font-bold text-gray-900">
//                           ₹{taxData.landTax.toLocaleString()}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td className="px-4 py-3 text-sm font-medium text-gray-900">
//                           <div className="flex items-center">
//                             <MdBusiness className="mr-2 text-purple-600" />
//                             {content[language].labels.buildingTax}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3 text-sm text-gray-600">
//                           {propertyData.buildingArea} sq. ft. × ₹15
//                         </td>
//                         <td className="px-4 py-3 text-sm font-bold text-gray-900">
//                           ₹{taxData.buildingTax.toLocaleString()}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td className="px-4 py-3 text-sm font-medium text-gray-900">
//                           <div className="flex items-center">
//                             <MdWaterDrop className="mr-2 text-cyan-600" />
//                             {content[language].labels.waterTax}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3 text-sm text-gray-600">
//                           {language === 'english' ? 'Fixed Charge' : 'निश्चित शुल्क'}
//                         </td>
//                         <td className="px-4 py-3 text-sm font-bold text-gray-900">
//                           ₹{taxData.waterTax.toLocaleString()}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td className="px-4 py-3 text-sm font-medium text-gray-900">
//                           <div className="flex items-center">
//                             <MdHealthAndSafety className="mr-2 text-red-600" />
//                             {content[language].labels.healthTax}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3 text-sm text-gray-600">
//                           8% of ₹{parseInt(propertyData.annualValue).toLocaleString()}
//                         </td>
//                         <td className="px-4 py-3 text-sm font-bold text-gray-900">
//                           ₹{taxData.healthTax.toLocaleString()}
//                         </td>
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               {/* Tax Summary */}
//               <div className="border-t-2 border-gray-300 pt-6">
//                 <div className="flex flex-col md:flex-row md:items-center justify-between mb-6">
//                   <div>
//                     <h4 className="text-lg font-bold text-gray-900 mb-2">
//                       {content[language].summary}
//                     </h4>
//                     <div className="grid grid-cols-2 gap-6">
//                       <div>
//                         <p className="text-sm text-gray-600">{content[language].labels.taxYear}</p>
//                         <p className="font-bold text-gray-900">{taxData.taxYear}</p>
//                       </div>
//                       <div>
//                         <p className="text-sm text-gray-600">{content[language].labels.dueDate}</p>
//                         <p className="font-bold text-gray-900">{taxData.dueDate}</p>
//                       </div>
//                     </div>
//                   </div>
                  
//                   <div className="mt-4 md:mt-0">
//                     <div className="bg-blue-50 p-4 rounded-lg">
//                       <div className="flex justify-between items-center">
//                         <div>
//                           <p className="text-sm text-gray-600">{content[language].labels.totalTax}</p>
//                           <p className="text-2xl font-bold" style={{ color: colors.primary }}>
//                             ₹{taxData.totalTax.toLocaleString()}
//                           </p>
//                         </div>
//                         <div className="text-right">
//                           <p className="text-sm text-gray-600">{content[language].labels.paymentMode}</p>
//                           <p className="font-bold text-gray-900">Online</p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Important Notes */}
//                 <div className="bg-gray-50 p-4 rounded-lg mt-6">
//                   <h5 className="font-bold text-gray-900 mb-2">
//                     {language === 'english' ? 'Important Notes:' : 'महत्वाच्या सूचना:'}
//                   </h5>
//                   <ul className="text-sm text-gray-700 space-y-1">
//                     <li>• {content[language].notes.note1}</li>
//                     <li>• {content[language].notes.note2}</li>
//                     <li>• {content[language].notes.note3}</li>
//                     <li>• {content[language].notes.note4}</li>
//                   </ul>
//                 </div>

//                 {/* Footer */}
//                 <div className="mt-8 pt-6 border-t border-gray-300">
//                   <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//                     <div className="text-center">
//                       <div className="h-1 w-16 bg-gray-400 mx-auto mb-2"></div>
//                       <p className="text-sm text-gray-600">{content[language].labels.authorizedBy}</p>
//                     </div>
//                     <div className="text-center">
//                       <div className="h-1 w-16 bg-gray-400 mx-auto mb-2"></div>
//                       <p className="text-sm text-gray-600">Gram Panchayat Seal</p>
//                     </div>
//                     <div className="text-center">
//                       <div className="h-1 w-16 bg-gray-400 mx-auto mb-2"></div>
//                       <p className="text-sm text-gray-600">Government Stamp</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Actions Sidebar - Right Column */}
//         <div>
//           {/* Actions Card */}
//           <div className="bg-white rounded-xl shadow-lg p-6 mb-6 sticky top-6">
//             <div className="flex items-center mb-6">
//               <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center mr-4">
//                 <FiPrinter size={24} className="text-blue-600" />
//               </div>
//               <div>
//                 <h2 className="text-xl font-bold text-gray-800">
//                   {language === 'english' ? 'Print & Export' : 'प्रिंट आणि निर्यात'}
//                 </h2>
//                 <p className="text-gray-600 text-sm">
//                   {language === 'english' 
//                     ? 'Print or download the receipt'
//                     : 'पावती प्रिंट किंवा डाउनलोड करा'}
//                 </p>
//               </div>
//             </div>

//             {/* Action Buttons */}
//             <div className="space-y-3">
//               <button
//                 onClick={handlePrint}
//                 className="w-full inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-medium rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200"
//               >
//                 <FiPrinter className="mr-2" />
//                 {content[language].buttons.print}
//               </button>

//               <button
//                 onClick={handleDownload}
//                 disabled={generatingPDF}
//                 className={`w-full inline-flex items-center justify-center px-6 py-3 rounded-lg font-medium shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 ${
//                   generatingPDF
//                     ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
//                     : 'bg-gradient-to-r from-green-600 to-green-700 text-white'
//                 }`}
//               >
//                 {generatingPDF ? (
//                   <>
//                     <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
//                     {content[language].messages.generating}
//                   </>
//                 ) : (
//                   <>
//                     <FiDownload className="mr-2" />
//                     {content[language].buttons.downloadPDF}
//                   </>
//                 )}
//               </button>

//               <button
//                 onClick={generatePDF}
//                 className="w-full inline-flex items-center justify-center px-6 py-3 bg-white border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors duration-200"
//               >
//                 <MdPictureAsPdf className="mr-2" />
//                 {content[language].buttons.generatePDF}
//               </button>

//               <button
//                 onClick={handleShare}
//                 className="w-full inline-flex items-center justify-center px-6 py-3 bg-white border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors duration-200"
//               >
//                 <FiShare2 className="mr-2" />
//                 {content[language].buttons.share}
//               </button>

//               <button
//                 onClick={handleEmail}
//                 className="w-full inline-flex items-center justify-center px-6 py-3 bg-white border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors duration-200"
//               >
//                 <FiMail className="mr-2" />
//                 {content[language].buttons.email}
//               </button>

//               <button
//                 onClick={handleBack}
//                 className="w-full inline-flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 transition-colors duration-200"
//               >
//                 <FiArrowLeft className="mr-2" />
//                 {content[language].buttons.back}
//               </button>
//             </div>

//             {/* Receipt Info */}
//             <div className="mt-6 pt-6 border-t border-gray-200">
//               <h3 className="font-bold text-gray-800 mb-3">
//                 {language === 'english' ? 'Receipt Information' : 'पावती माहिती'}
//               </h3>
//               <div className="space-y-2">
//                 <div className="flex justify-between">
//                   <span className="text-sm text-gray-600">{content[language].labels.receiptNo}</span>
//                   <span className="text-sm font-medium">{taxData.receiptNumber}</span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span className="text-sm text-gray-600">{content[language].labels.propertyId}</span>
//                   <span className="text-sm font-medium">{propertyData.sequenceNumber}</span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span className="text-sm text-gray-600">{content[language].labels.totalTax}</span>
//                   <span className="text-sm font-bold text-green-700">₹{taxData.totalTax.toLocaleString()}</span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span className="text-sm text-gray-600">{content[language].labels.paymentStatus}</span>
//                   <span className="text-sm font-medium text-green-600">PAID</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Print Styles */}
//       <style>{`
//         @media print {
//           body * {
//             visibility: hidden;
//           }
//           #pdf-content, #pdf-content * {
//             visibility: visible;
//           }
//           #pdf-content {
//             position: absolute;
//             left: 0;
//             top: 0;
//             width: 100%;
//             box-shadow: none;
//           }
//           .no-print {
//             display: none !important;
//           }
//         }
//       `}</style>

//       {/* Footer Note */}
//       <div className="mt-8 text-center text-sm text-gray-500">
//         <p>
//           {language === 'english' 
//             ? '© 2024 Government of Maharashtra. All rights reserved.'
//             : '© २०२४ महाराष्ट्र शासन. सर्व हक्क राखीव.'}
//         </p>
//         <p className="mt-1">
//           {language === 'english'
//             ? 'Official Property Tax Receipt System'
//             : 'अधिकृत मालमत्ता कर पावती प्रणाली'}
//         </p>
//       </div>
//     </div>
//   );
// };

// export default PrintPDF;





import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { 
  FiPrinter, 
  FiDownload, 
  FiFileText,
  FiHome,
  FiUser,
  FiMapPin,
  FiCalendar,
  FiCheckCircle,
  FiArrowLeft,
  FiShare2,
  FiMail,
  FiExternalLink,
  FiClock,
  FiInfo
} from 'react-icons/fi';
import {
  MdAttachMoney,
  MdPictureAsPdf,
  MdReceiptLong,
  MdWaterDrop,
  MdHealthAndSafety,
  MdLandscape,
  MdBusiness,
  MdAccountBalance,
  MdLocationCity,
  MdHistory,
  MdVerified
} from 'react-icons/md';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const PrintPDF = () => {
  const { propertyId, year } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const pdfRef = useRef();
  const [language, setLanguage] = useState('english');
  const [propertyData, setPropertyData] = useState(null);
  const [taxData, setTaxData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [generatingPDF, setGeneratingPDF] = useState(false);
  const [pdfGenerated, setPdfGenerated] = useState(false);

  // Government of Maharashtra color scheme
  const colors = {
    primary: '#003366',
    secondary: '#FF9933',
    accent: '#138808',
    white: '#FFFFFF'
  };

  // Language content
  const content = {
    english: {
      pageTitle: 'Print Tax Receipt - Read Only',
      pageSubtitle: 'View and download official tax receipt for the selected year',
      preview: 'Official Receipt Preview',
      receiptDetails: 'Receipt Details',
      propertyInfo: 'Property Information',
      taxBreakdown: 'Tax Breakdown',
      summary: 'Tax Summary',
      headers: {
        maharashtraGovt: 'Government of Maharashtra',
        department: 'Revenue Department',
        receiptTitle: 'PROPERTY TAX RECEIPT',
        receiptSubtitle: 'नमुना ८ (Format 8)',
        gramPanchayat: 'Grampanchayat  Corporation'
      },
      labels: {
        receiptNo: 'Receipt No.',
        date: 'Receipt Date',
        propertyId: 'Property ID',
        ownerName: 'Owner Name',
        address: 'Address',
        landArea: 'Land Area',
        buildingArea: 'Building Area',
        buildingType: 'Building Type',
        wardNo: 'Ward No.',
        zone: 'Zone',
        landTax: 'Land Tax',
        buildingTax: 'Building Tax',
        waterTax: 'Water Tax',
        healthTax: 'Health Tax',
        educationCess: 'Education Cess',
        otherCharges: 'Other Charges',
        totalTax: 'Total Tax',
        taxYear: 'Assessment Year',
        dueDate: 'Due Date',
        paymentMode: 'Payment Mode',
        paymentStatus: 'Payment Status',
        authorizedBy: 'Authorized Signature',
        assessmentYear: 'Assessment Year',
        calculationMethod: 'Calculation Method'
      },
      buttons: {
        print: 'Print Receipt',
        downloadPDF: 'Download PDF',
        generatePDF: 'Generate PDF',
        share: 'Share',
        email: 'Email PDF',
        back: 'Back to Tax History',
        viewHistory: 'View Tax History'
      },
      messages: {
        loading: 'Loading receipt data...',
        generating: 'Generating PDF...',
        generated: 'PDF generated successfully!',
        downloading: 'Downloading PDF...',
        printed: 'Receipt printed successfully!',
        readOnly: 'Read-Only View',
        assessmentYear: 'Assessment Year',
        noData: 'No tax data found for selected year'
      },
      notes: {
        note1: 'This is an official receipt for property tax payment.',
        note2: 'Please keep this receipt for future reference.',
        note3: 'Late payments will attract penalty charges.',
        note4: 'For any queries, contact Grampanchayat  Corporation office.',
        note5: 'Receipt cannot be modified after generation.'
      }
    },
    marathi: {
      pageTitle: 'कर पावती प्रिंट - फक्त वाचनासाठी',
      pageSubtitle: 'निवडलेल्या वर्षासाठी अधिकृत कर पावती पहा आणि डाउनलोड करा',
      preview: 'अधिकृत पावती पूर्वावलोकन',
      receiptDetails: 'पावती तपशील',
      propertyInfo: 'मालमत्ता माहिती',
      taxBreakdown: 'कर विभागणी',
      summary: 'कर सारांश',
      headers: {
        maharashtraGovt: 'महाराष्ट्र शासन',
        department: 'राजस्व विभाग',
        receiptTitle: 'मालमत्ता कर पावती',
        receiptSubtitle: 'नमुना ८ (Format 8)',
        gramPanchayat: 'महानगरपालिका'
      },
      labels: {
        receiptNo: 'पावती क्रमांक',
        date: 'पावती तारीख',
        propertyId: 'मालमत्ता आयडी',
        ownerName: 'मालकाचे नाव',
        address: 'पत्ता',
        landArea: 'जमीन क्षेत्रफळ',
        buildingArea: 'इमारत क्षेत्रफळ',
        buildingType: 'इमारत प्रकार',
        wardNo: 'वॉर्ड क्रमांक',
        zone: 'विभाग',
        landTax: 'जमीन कर',
        buildingTax: 'इमारत कर',
        waterTax: 'पाणी कर',
        healthTax: 'आरोग्य कर',
        educationCess: 'शिक्षण उपकर',
        otherCharges: 'इतर शुल्क',
        totalTax: 'एकूण कर',
        taxYear: 'मूल्यांकन वर्ष',
        dueDate: 'पेमेंट कालबाह्य',
        paymentMode: 'पेमेंट पद्धत',
        paymentStatus: 'पेमेंट स्थिती',
        authorizedBy: 'अधिकृत सही',
        assessmentYear: 'मूल्यांकन वर्ष',
        calculationMethod: 'गणना पद्धत'
      },
      buttons: {
        print: 'पावती प्रिंट करा',
        downloadPDF: 'पीडीएफ डाउनलोड करा',
        generatePDF: 'पीडीएफ तयार करा',
        share: 'शेअर करा',
        email: 'पीडीएफ ईमेल करा',
        back: 'कर इतिहासाकडे परत',
        viewHistory: 'कर इतिहास पहा'
      },
      messages: {
        loading: 'पावती डेटा लोड करत आहे...',
        generating: 'पीडीएफ तयार करत आहे...',
        generated: 'पीडीएफ यशस्वीरित्या तयार केली!',
        downloading: 'पीडीएफ डाउनलोड करत आहे...',
        printed: 'पावती यशस्वीरित्या प्रिंट केली!',
        readOnly: 'फक्त वाचनासाठी दृश्य',
        assessmentYear: 'मूल्यांकन वर्ष',
        noData: 'निवडलेल्या वर्षासाठी कर डेटा सापडला नाही'
      },
      notes: {
        note1: 'ही मालमत्ता कर पेमेंटसाठी अधिकृत पावती आहे.',
        note2: 'भविष्यातील संदर्भासाठी ही पावती जतन करा.',
        note3: 'उशीरा पेमेंटसाठी दंड शुल्क आकारले जाईल.',
        note4: 'कोणत्याही प्रश्नासाठी, ग्रामपंचायतकार्यालयाशी संपर्क साधा.',
        note5: 'पावती व्युत्पन्न केल्यानंतर सुधारता येत नाही.'
      }
    }
  };

  // Format currency in Indian Rupees
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return new Date().toLocaleDateString('en-IN');
    return new Date(dateString).toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  // Load tax data from localStorage
  const loadTaxData = () => {
    try {
      // Load property data
      const properties = JSON.parse(localStorage.getItem('propertyList') || '[]');
      const property = properties.find(p => p.id === propertyId) || 
                       properties.find(p => p.sequenceNumber === propertyId);
      
      if (!property) {
        throw new Error('Property not found');
      }
      
      setPropertyData(property);
      
      // Load tax history
      const taxHistory = JSON.parse(localStorage.getItem('taxHistory') || '{}');
      const propertyTaxes = taxHistory[propertyId] || {};
      const yearTaxData = propertyTaxes[year] || propertyTaxes[getCurrentFinancialYear()];
      
      if (!yearTaxData) {
        throw new Error('No tax data for selected year');
      }
      
      setTaxData(yearTaxData);
    } catch (error) {
      console.error('Error loading tax data:', error);
      // Fallback to sample data for demo
      setPropertyData({
        sequenceNumber: propertyId || 'PR-2024-1001',
        ownerName: 'राजेश कुमार',
        address: 'हाउस नंबर १२३, शिवाजी नगर, पुणे - ४११०४२',
        landArea: '1200',
        buildingArea: '1500',
        buildingType: 'Residential',
        annualValue: '72000',
        capitalValue: '1800000',
        registrationDate: '१५ जानेवारी २०२४',
        wardNumber: '१२',
        zone: 'पुणे विभाग'
      });
      
      setTaxData({
        assessmentYear: year || getCurrentFinancialYear(),
        landTax: 12000,
        buildingTax: 22500,
        waterTax: 8000,
        healthTax: 5760,
        educationCess: 690,
        otherCharges: 3000,
        totalTax: 52950,
        dueDate: '३१ मार्च २०२५',
        receiptNumber: `RCPT-${(year || getCurrentFinancialYear()).split('-')[0]}-${Math.floor(1000 + Math.random() * 9000)}`,
        issueDate: new Date().toISOString(),
        paymentStatus: 'paid',
        paymentMode: 'online',
        status: 'saved',
        savedDate: new Date().toISOString()
      });
    }
  };

  // Get current financial year
  const getCurrentFinancialYear = () => {
    const currentYear = new Date().getFullYear();
    const nextYear = currentYear + 1;
    return `${currentYear}-${nextYear.toString().slice(2)}`;
  };

  // Load data
  useEffect(() => {
    setLoading(true);
    
    // Simulate API call with timeout
    setTimeout(() => {
      loadTaxData();
      setLoading(false);
    }, 800);
  }, [propertyId, year]);

  const generatePDF = async () => {
    setGeneratingPDF(true);
    
    try {
      const input = pdfRef.current;
      const canvas = await html2canvas(input, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff'
      });
      
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 190;
      const pageHeight = 295;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 10;

      pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      const fileName = `Property_Tax_Receipt_${propertyData?.sequenceNumber}_${year || taxData?.assessmentYear}.pdf`;
      pdf.save(fileName);
      setPdfGenerated(true);
      
      // Show success message
      const message = language === 'english' 
        ? `PDF generated successfully: ${fileName}`
        : `PDF यशस्वीरित्या तयार केली: ${fileName}`;
      alert(message);
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert(language === 'english' 
        ? 'Error generating PDF. Please try again.' 
        : 'PDF तयार करताना त्रुटी. कृपया पुन्हा प्रयत्न करा.');
    } finally {
      setGeneratingPDF(false);
    }
  };

  const handlePrint = () => {
    window.print();
    alert(content[language].messages.printed);
  };

  const handleDownload = () => {
    generatePDF();
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: `${content[language].headers.receiptTitle} - ${propertyData?.sequenceNumber}`,
        text: `${content[language].headers.receiptTitle} for ${propertyData?.sequenceNumber}, Amount: ${formatCurrency(taxData?.totalTax || 0)}`,
        url: window.location.href
      });
    } else {
      alert(language === 'english' 
        ? 'Share functionality requires a secure context (HTTPS) and browser support.' 
        : 'शेअर कार्यक्षमतेसाठी सुरक्षित संदर्भ (HTTPS) आणि ब्राउझर समर्थन आवश्यक आहे.');
    }
  };

  const handleEmail = () => {
    const subject = `${content[language].headers.receiptTitle} - ${propertyData?.sequenceNumber}`;
    const body = `
${content[language].headers.receiptTitle}
${content[language].labels.propertyId}: ${propertyData?.sequenceNumber}
${content[language].labels.ownerName}: ${propertyData?.ownerName}
${content[language].labels.taxYear}: ${taxData?.assessmentYear}
${content[language].labels.totalTax}: ${formatCurrency(taxData?.totalTax || 0)}
${content[language].labels.receiptNo}: ${taxData?.receiptNumber}
    `;
    
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  const handleBack = () => {
    navigate(`/tax-history/${propertyId}`);
  };

  const handleViewHistory = () => {
    navigate(`/tax-history/${propertyId}`);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-blue-50 to-white">
        <div className="text-center">
          <div className="w-20 h-20 mx-auto mb-6 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">
            {content[language].messages.loading}
          </h3>
          <p className="text-gray-600 max-w-md">
            {language === 'english' 
              ? `Loading tax receipt for assessment year: ${year || taxData?.assessmentYear || 'Current Year'}`
              : `मूल्यांकन वर्षासाठी कर पावती लोड करत आहे: ${year || taxData?.assessmentYear || 'चालू वर्ष'}`
            }
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-4 md:p-6 bg-gradient-to-b from-gray-50 to-gray-100">
      {/* Header */}
      <div className="mb-8">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
              {content[language].pageTitle}
            </h1>
            <div className="flex flex-wrap items-center gap-2">
              <p className="text-gray-600">
                {content[language].pageSubtitle}
              </p>
              <span className="px-3 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full">
                {content[language].messages.readOnly}
              </span>
            </div>
          </div>
          
          {/* Language Toggle */}
          <div className="mt-4 md:mt-0">
            <div className="inline-flex rounded-lg border border-gray-300 p-1 bg-white shadow-sm">
              <button
                onClick={() => setLanguage('english')}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
                  language === 'english'
                    ? 'bg-blue-600 text-white shadow-sm'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                English
              </button>
              <button
                onClick={() => setLanguage('marathi')}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
                  language === 'marathi'
                    ? 'bg-blue-600 text-white shadow-sm'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                मराठी
              </button>
            </div>
          </div>
        </div>

        {/* Assessment Year Banner */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-xl shadow-lg p-6 mb-6 text-white">
          <div className="flex flex-col md:flex-row md:items-center justify-between">
            <div className="flex items-center mb-4 md:mb-0">
              <div className="w-12 h-12 rounded-lg bg-white bg-opacity-20 flex items-center justify-center mr-4">
                <FiCalendar size={24} />
              </div>
              <div>
                <h2 className="text-xl font-bold">
                  {content[language].messages.assessmentYear}
                </h2>
                <p className="opacity-90">
                  {language === 'english' 
                    ? `Viewing tax receipt for assessment year`
                    : `मूल्यांकन वर्षासाठी कर पावती पहात आहे`
                  }
                </p>
              </div>
            </div>
            
            <div className="text-center md:text-right">
              <div className="text-3xl font-bold mb-1">{taxData?.assessmentYear || year || getCurrentFinancialYear()}</div>
              <div className="text-sm opacity-90 bg-white bg-opacity-20 px-3 py-1 rounded-full inline-block">
                {language === 'english' ? 'Financial Year' : 'आर्थिक वर्ष'}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* PDF Preview - Left Column */}
        <div className="lg:col-span-2">
          <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border border-gray-200 hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center">
                <div className="w-10 h-10 rounded-lg bg-red-100 flex items-center justify-center mr-4">
                  <MdPictureAsPdf size={24} className="text-red-600" />
                </div>
                <div>
                  <h2 className="text-xl font-bold text-gray-800">
                    {content[language].preview}
                  </h2>
                  <p className="text-gray-600 text-sm">
                    {language === 'english' 
                      ? 'Official tax receipt preview (Read-Only)'
                      : 'अधिकृत कर पावती पूर्वावलोकन (फक्त वाचनासाठी)'}
                  </p>
                </div>
              </div>
              
              <div className="flex items-center space-x-2">
                <span className={`px-3 py-1 text-xs font-medium rounded-full ${
                  pdfGenerated ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                }`}>
                  {pdfGenerated 
                    ? (language === 'english' ? 'PDF Ready' : 'PDF तयार') 
                    : (language === 'english' ? 'Preview Mode' : 'पूर्वावलोकन मोड')}
                </span>
                <span className="px-3 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800">
                  {language === 'english' ? 'Read-Only' : 'फक्त वाचनासाठी'}
                </span>
              </div>
            </div>

            {/* PDF Content */}
            <div 
              ref={pdfRef}
              className="bg-white border-2 border-gray-300 rounded-lg p-6 md:p-8 print:border-0 print:shadow-none print:p-0"
              style={{ minHeight: '800px' }}
              id="pdf-content"
            >
              {/* Government Header */}
              <div className="text-center mb-8 border-b-2 border-gray-300 pb-6 print:border-b-2">
                <div className="flex flex-col items-center mb-4">
                  <div className="w-20 h-20 rounded-full bg-gradient-to-r from-blue-600 to-blue-800 flex items-center justify-center mb-4">
                    <span className="text-white text-3xl font-bold">म</span>
                  </div>
                  <div>
                    <h1 className="text-2xl font-bold text-gray-900 mb-2" style={{ color: colors.primary }}>
                      {content[language].headers.maharashtraGovt}
                    </h1>
                    <h2 className="text-lg text-gray-700 font-medium">
                      {content[language].headers.department}
                    </h2>
                  </div>
                </div>
                
                <div className="mt-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2 tracking-wide">
                    {content[language].headers.receiptTitle}
                  </h3>
                  <div className="flex flex-col md:flex-row md:items-center md:justify-center gap-4">
                    <p className="text-gray-700 font-medium bg-gray-100 px-4 py-2 rounded-lg">
                      {content[language].headers.receiptSubtitle}
                    </p>
                    <p className="text-gray-600">
                      {content[language].headers.gramPanchayat}
                    </p>
                  </div>
                </div>
              </div>

              {/* Assessment Year Highlight */}
              <div className="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <FiCalendar className="mr-3 text-blue-600" />
                    <div>
                      <p className="text-sm text-gray-600">{content[language].labels.assessmentYear}</p>
                      <p className="font-bold text-lg text-blue-700">{taxData?.assessmentYear || year}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-gray-600">{content[language].labels.calculationMethod}</p>
                    <p className="font-bold text-gray-900">नमुना ८</p>
                  </div>
                </div>
              </div>

              {/* Receipt Details */}
              <div className="mb-8">
                <div className="flex flex-col md:flex-row md:items-center justify-between mb-6">
                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                      <MdReceiptLong className="mr-2" />
                      {content[language].receiptDetails}
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="bg-gray-50 p-3 rounded-lg">
                        <p className="text-sm text-gray-600">{content[language].labels.receiptNo}</p>
                        <p className="font-bold text-gray-900 font-mono">{taxData?.receiptNumber || 'N/A'}</p>
                      </div>
                      <div className="bg-gray-50 p-3 rounded-lg">
                        <p className="text-sm text-gray-600">{content[language].labels.date}</p>
                        <p className="font-bold text-gray-900">{formatDate(taxData?.issueDate)}</p>
                      </div>
                      <div className="bg-gray-50 p-3 rounded-lg">
                        <p className="text-sm text-gray-600">{content[language].labels.propertyId}</p>
                        <p className="font-bold text-gray-900 font-mono">{propertyData?.sequenceNumber || 'N/A'}</p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 md:mt-0 md:text-right">
                    <div className="inline-flex items-center px-4 py-2 bg-green-100 text-green-800 rounded-lg font-bold">
                      <FiCheckCircle className="mr-2" />
                      <span>{taxData?.paymentStatus?.toUpperCase() || 'PAID'}</span>
                    </div>
                    <p className="text-sm text-gray-600 mt-2">
                      {content[language].labels.paymentMode}: {taxData?.paymentMode || 'Online'}
                    </p>
                  </div>
                </div>
              </div>

              {/* Property Information */}
              <div className="mb-8">
                <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                  <FiHome className="mr-2" />
                  {content[language].propertyInfo}
                </h4>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    <div>
                      <p className="text-sm text-gray-600">{content[language].labels.ownerName}</p>
                      <p className="font-bold text-gray-900">{propertyData?.ownerName || 'N/A'}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">{content[language].labels.address}</p>
                      <p className="font-bold text-gray-900">{propertyData?.address || 'N/A'}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-sm text-gray-600">{content[language].labels.wardNo}</p>
                        <p className="font-bold text-gray-900">{propertyData?.wardNumber || 'N/A'}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-600">{content[language].labels.zone}</p>
                        <p className="font-bold text-gray-900">{propertyData?.zone || 'N/A'}</p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="space-y-4">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-sm text-gray-600">{content[language].labels.landArea}</p>
                        <p className="font-bold text-gray-900">
                          {propertyData?.landArea ? `${parseInt(propertyData.landArea).toLocaleString()} sq. ft.` : 'N/A'}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-600">{content[language].labels.buildingArea}</p>
                        <p className="font-bold text-gray-900">
                          {propertyData?.buildingArea ? `${parseInt(propertyData.buildingArea).toLocaleString()} sq. ft.` : 'N/A'}
                        </p>
                      </div>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">{content[language].labels.buildingType}</p>
                      <p className="font-bold text-gray-900">{propertyData?.buildingType || 'N/A'}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Registration Date</p>
                      <p className="font-bold text-gray-900">{propertyData?.registrationDate || 'N/A'}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Tax Breakdown */}
              <div className="mb-8">
                <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                  <MdReceiptLong className="mr-2" />
                  {content[language].taxBreakdown}
                </h4>
                
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">
                          {language === 'english' ? 'Tax Component' : 'कर घटक'}
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">
                          {language === 'english' ? 'Calculation' : 'गणना'}
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">
                          {language === 'english' ? 'Amount (₹)' : 'रक्कम (₹)'}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {/* Land Tax */}
                      <tr>
                        <td className="px-4 py-3">
                          <div className="flex items-center">
                            <MdLandscape className="mr-2 text-blue-600" />
                            <span className="font-medium text-gray-900">{content[language].labels.landTax}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600">
                          {propertyData?.landArea || 0} sq. ft. × ₹10
                        </td>
                        <td className="px-4 py-3 font-bold text-gray-900">
                          {formatCurrency(taxData?.landTax || 0)}
                        </td>
                      </tr>
                      
                      {/* Building Tax */}
                      <tr>
                        <td className="px-4 py-3">
                          <div className="flex items-center">
                            <MdBusiness className="mr-2 text-purple-600" />
                            <span className="font-medium text-gray-900">{content[language].labels.buildingTax}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600">
                          {propertyData?.buildingArea || 0} sq. ft. × ₹15
                        </td>
                        <td className="px-4 py-3 font-bold text-gray-900">
                          {formatCurrency(taxData?.buildingTax || 0)}
                        </td>
                      </tr>
                      
                      {/* Water Tax */}
                      <tr>
                        <td className="px-4 py-3">
                          <div className="flex items-center">
                            <MdWaterDrop className="mr-2 text-cyan-600" />
                            <span className="font-medium text-gray-900">{content[language].labels.waterTax}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600">
                          {language === 'english' ? 'Fixed Charge' : 'निश्चित शुल्क'}
                        </td>
                        <td className="px-4 py-3 font-bold text-gray-900">
                          {formatCurrency(taxData?.waterTax || 0)}
                        </td>
                      </tr>
                      
                      {/* Health Tax */}
                      <tr>
                        <td className="px-4 py-3">
                          <div className="flex items-center">
                            <MdHealthAndSafety className="mr-2 text-red-600" />
                            <span className="font-medium text-gray-900">{content[language].labels.healthTax}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600">
                          8% of Annual Value
                        </td>
                        <td className="px-4 py-3 font-bold text-gray-900">
                          {formatCurrency(taxData?.healthTax || 0)}
                        </td>
                      </tr>
                      
                      {/* Education Cess */}
                      <tr>
                        <td className="px-4 py-3">
                          <div className="flex items-center">
                            <FiFileText className="mr-2 text-yellow-600" />
                            <span className="font-medium text-gray-900">{content[language].labels.educationCess}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600">
                          2% of (Land + Building Tax)
                        </td>
                        <td className="px-4 py-3 font-bold text-gray-900">
                          {formatCurrency(taxData?.educationCess || 0)}
                        </td>
                      </tr>
                      
                      {/* Other Charges */}
                      <tr>
                        <td className="px-4 py-3">
                          <div className="flex items-center">
                            <MdReceiptLong className="mr-2 text-gray-600" />
                            <span className="font-medium text-gray-900">{content[language].labels.otherCharges}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600">
                          {language === 'english' ? 'Grampanchayat  Service Charges' : 'ग्रामपंचायतसेवा शुल्क'}
                        </td>
                        <td className="px-4 py-3 font-bold text-gray-900">
                          {formatCurrency(taxData?.otherCharges || 0)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Tax Summary */}
              <div className="border-t-2 border-gray-300 pt-6">
                <div className="flex flex-col md:flex-row md:items-center justify-between mb-6">
                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-4">
                      {content[language].summary}
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <p className="text-sm text-gray-600">{content[language].labels.taxYear}</p>
                        <p className="font-bold text-gray-900 text-lg">{taxData?.assessmentYear || year}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-600">{content[language].labels.dueDate}</p>
                        <p className="font-bold text-gray-900 text-lg">{taxData?.dueDate || '31 March ' + (year?.split('-')[1] ? '20' + year.split('-')[1] : '2025')}</p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="mt-6 md:mt-0">
                    <div className="bg-gradient-to-r from-blue-50 to-blue-100 p-6 rounded-lg border border-blue-200">
                      <div className="flex justify-between items-center">
                        <div>
                          <p className="text-sm text-gray-600">{content[language].labels.totalTax}</p>
                          <p className="text-3xl font-bold" style={{ color: colors.primary }}>
                            {formatCurrency(taxData?.totalTax || 0)}
                          </p>
                        </div>
                        <div className="text-right">
                          <div className="text-sm text-gray-600">{content[language].labels.paymentStatus}</div>
                          <div className="font-bold text-green-700">{taxData?.paymentStatus?.toUpperCase() || 'PAID'}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Important Notes */}
                <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 mt-6">
                  <h5 className="font-bold text-gray-900 mb-3 flex items-center">
                    <FiInfo className="mr-2 text-blue-600" />
                    {language === 'english' ? 'Important Notes:' : 'महत्वाच्या सूचना:'}
                  </h5>
                  <ul className="text-sm text-gray-700 space-y-2">
                    <li className="flex items-start">
                      <span className="text-blue-600 mr-2">•</span>
                      <span>{content[language].notes.note1}</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-600 mr-2">•</span>
                      <span>{content[language].notes.note2}</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-600 mr-2">•</span>
                      <span>{content[language].notes.note3}</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-600 mr-2">•</span>
                      <span>{content[language].notes.note4}</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-600 mr-2">•</span>
                      <span className="font-medium">{content[language].notes.note5}</span>
                    </li>
                  </ul>
                </div>

                {/* Footer with Signatures */}
                <div className="mt-8 pt-6 border-t border-gray-300">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="text-center">
                      <div className="h-px w-16 bg-gray-400 mx-auto mb-2"></div>
                      <p className="text-sm text-gray-600">{content[language].labels.authorizedBy}</p>
                      <div className="mt-4 h-12 border-t border-dashed border-gray-400"></div>
                    </div>
                    <div className="text-center">
                      <div className="h-px w-16 bg-gray-400 mx-auto mb-2"></div>
                      <p className="text-sm text-gray-600">Grampanchayat  Corporation Seal</p>
                      <div className="mt-4 h-12 w-12 rounded-full border-2 border-gray-400 border-dashed mx-auto flex items-center justify-center">
                        <span className="text-gray-500 text-xs">SEAL</span>
                      </div>
                    </div>
                    <div className="text-center">
                      <div className="h-px w-16 bg-gray-400 mx-auto mb-2"></div>
                      <p className="text-sm text-gray-600">Government Stamp</p>
                      <div className="mt-4 h-12 border-b border-dashed border-gray-400"></div>
                    </div>
                  </div>
                  
                  <div className="text-center mt-8 pt-4 border-t border-gray-300">
                    <p className="text-xs text-gray-500">
                      {language === 'english' 
                        ? 'This is a system generated receipt. No physical signature required.'
                        : 'ही सिस्टीम व्युत्पन्न पावती आहे. भौतिक सहीची आवश्यकता नाही.'}
                    </p>
                    <p className="text-xs text-gray-500 mt-1">
                      Generated on: {new Date().toLocaleString()}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Actions Sidebar - Right Column */}
        <div>
          {/* Actions Card */}
          <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border border-gray-200 sticky top-6">
            <div className="flex items-center mb-6">
              <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center mr-4">
                <FiPrinter size={24} className="text-blue-600" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-800">
                  {language === 'english' ? 'Print & Export' : 'प्रिंट आणि निर्यात'}
                </h2>
                <p className="text-gray-600 text-sm">
                  {language === 'english' 
                    ? 'Print or download the official receipt'
                    : 'अधिकृत पावती प्रिंट किंवा डाउनलोड करा'}
                </p>
              </div>
            </div>

            {/* Assessment Year Info */}
            <div className="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-700">{content[language].labels.assessmentYear}</span>
                <span className="font-bold text-blue-700">{taxData?.assessmentYear || year}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-gray-700">{content[language].labels.receiptNo}</span>
                <span className="font-mono text-sm">{taxData?.receiptNumber}</span>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="space-y-3">
              <button
                onClick={handlePrint}
                className="w-full inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-medium rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200"
              >
                <FiPrinter className="mr-2" />
                {content[language].buttons.print}
              </button>

              <button
                onClick={handleDownload}
                disabled={generatingPDF}
                className={`w-full inline-flex items-center justify-center px-6 py-3 rounded-lg font-medium shadow-md hover:shadow-lg transition-all duration-200 ${
                  generatingPDF
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : 'bg-gradient-to-r from-green-600 to-green-700 text-white hover:-translate-y-0.5'
                }`}
              >
                {generatingPDF ? (
                  <>
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                    {content[language].messages.generating}
                  </>
                ) : (
                  <>
                    <FiDownload className="mr-2" />
                    {content[language].buttons.downloadPDF}
                  </>
                )}
              </button>

              <button
                onClick={handleViewHistory}
                className="w-full inline-flex items-center justify-center px-6 py-3 bg-white border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
              >
                <MdHistory className="mr-2" />
                {content[language].buttons.viewHistory}
              </button>

              <button
                onClick={handleShare}
                className="w-full inline-flex items-center justify-center px-6 py-3 bg-white border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
              >
                <FiShare2 className="mr-2" />
                {content[language].buttons.share}
              </button>

              <button
                onClick={handleEmail}
                className="w-full inline-flex items-center justify-center px-6 py-3 bg-white border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
              >
                <FiMail className="mr-2" />
                {content[language].buttons.email}
              </button>

              <button
                onClick={handleBack}
                className="w-full inline-flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 font-medium rounded-lg border border-gray-300 hover:bg-gray-200 hover:border-gray-400 transition-all duration-200"
              >
                <FiArrowLeft className="mr-2" />
                {content[language].buttons.back}
              </button>
            </div>

            {/* Receipt Info */}
            <div className="mt-6 pt-6 border-t border-gray-200">
              <h3 className="font-bold text-gray-800 mb-3 flex items-center">
                <FiInfo className="mr-2" />
                {language === 'english' ? 'Receipt Information' : 'पावती माहिती'}
              </h3>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-sm text-gray-600">{content[language].labels.propertyId}</span>
                  <span className="text-sm font-medium">{propertyData?.sequenceNumber}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm text-gray-600">{content[language].labels.totalTax}</span>
                  <span className="text-sm font-bold text-green-700">{formatCurrency(taxData?.totalTax || 0)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm text-gray-600">{content[language].labels.paymentStatus}</span>
                  <span className="text-sm font-medium text-green-600">{taxData?.paymentStatus?.toUpperCase() || 'PAID'}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm text-gray-600">Generated Date</span>
                  <span className="text-sm">{formatDate(taxData?.savedDate)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          body * {
            visibility: hidden;
          }
          #pdf-content, #pdf-content * {
            visibility: visible;
          }
          #pdf-content {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            box-shadow: none;
            margin: 0;
            padding: 20px;
          }
          .no-print {
            display: none !important;
          }
        }
      `}</style>

      {/* Fixed Status Bar */}
      <div className="fixed bottom-4 right-4 bg-white rounded-lg shadow-lg p-4 border border-gray-200 max-w-sm z-40 hover:shadow-xl transition-shadow duration-300 no-print">
        <div className="flex items-center space-x-3">
          <div className="w-3 h-3 rounded-full animate-pulse bg-green-500"></div>
          <div>
            <p className="font-medium text-sm text-gray-800">
              {language === 'english' ? 'Receipt Ready' : 'पावती तयार'}
            </p>
            <p className="text-xs text-gray-500">
              {language === 'english' 
                ? `Assessment Year: ${taxData?.assessmentYear || year}`
                : `मूल्यांकन वर्ष: ${taxData?.assessmentYear || year}`}
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 pt-6 border-t border-gray-200">
        <div className="text-center text-sm text-gray-500">
          <p>
            {language === 'english' 
              ? '© 2024 Government of Maharashtra - Revenue Department. All rights reserved.'
              : '© २०२४ महाराष्ट्र शासन - राजस्व विभाग. सर्व हक्क राखीव.'}
          </p>
          <p className="mt-1">
            {language === 'english'
              ? 'Official Property Tax Receipt System | Format: नमुना ८'
              : 'अधिकृत मालमत्ता कर पावती प्रणाली | स्वरूप: नमुना ८'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrintPDF;